<div class="flex min-w-0 flex-auto flex-col">
  <!-- Header -->
  <div class="bg-card">
    <div class="mx-auto flex w-full max-w-screen-xl flex-col px-6 sm:px-8">
      <div
        class="my-8 flex min-w-0 flex-auto flex-col sm:my-12 sm:flex-row sm:items-center">
        <!-- Avatar and name -->
        <div class="flex min-w-0 flex-auto items-center">
          <div class="h-16 w-16 flex-0 overflow-hidden rounded-full">
            <img
              class="h-full w-full object-cover"
              src="images/avatars/brian-hughes.jpg" />
          </div>
          <div class="ml-4 flex min-w-0 flex-col">
            <ng-container *transloco="let t">
              <div
                class="truncate text-2xl font-semibold leading-7 tracking-tight md:text-5xl md:leading-snug">
                {{ 'WelcomeBack' | transloco }}, {{authService.user?.Name}}
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <!-- Project selector -->
      <div
        class="bg-default relative flex cursor-pointer self-start overflow-hidden rounded-t-xl border border-b-0 pb-1 pl-5 pr-4 pt-2"
        matRipple>
        <div class="flex items-center">
          <div class="overflow-hidden">
            <div class="truncate font-medium leading-6">
              {{'MandatOverview' | transloco}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Main -->
  <div class="-mt-px flex-auto border-t pt-4 sm:pt-6">
    <div class="mx-auto w-full max-w-screen-xl">
      <!-- Tabs -->
      <mat-tab-group
        class="sm:px-2"
        mat-stretch-tabs="false"
        [animationDuration]="'0'"
        [(selectedIndex)]="selectedTabIndex">
        <!-- Summary -->
        <mat-tab [label]="'Summary' | transloco">
          <ng-template matTabContent>

            @if(data()?.yearlySummary) {
            <app-total-revenue
              [data]="data().yearlySummary"
              [year]="setYear"></app-total-revenue>
            }

            @if(data()?.vehicleStock) {
            <app-vehicle-stock [data]="data().vehicleStock"
              [range]="range"></app-vehicle-stock>
            }

            <div class="mt-8 grid w-full grid-cols-1 gap-8 xl:grid-cols-3">
              <!-- Recent transactions table -->
              <div
                class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl p-6  shadow">
                <div class="flex items-start justify-between">
                  <div
                    class="truncate text-lg font-medium leading-6 tracking-tight">
                    {{'Sellers' | transloco}}
                  </div>
                  <div class="ml-2">
                    <button
                      class="bg-hover h-6 min-h-6 rounded-full px-2"
                      mat-button
                      [matMenuTriggerFor]="conversionMenu">
                      <span
                        class="text-secondary text-sm font-medium">{{sellersPeriod()
                        | transloco}}</span>
                    </button>
                    <mat-menu #conversionMenu="matMenu">
                      <button mat-menu-item
                        (click)="sellersPeriod.set('30 days')">{{'Last30Days' |
                        transloco}}</button>
                      <button mat-menu-item
                        (click)="sellersPeriod.set('3 months')">{{'Last3Months'
                        | transloco}}</button>
                      <button mat-menu-item
                        (click)="sellersPeriod.set('6 months')">{{'Last6Months'
                        | transloco}}</button>
                      <button mat-menu-item
                        (click)="sellersPeriod.set('9 months')">{{'Last9Months'
                        | transloco}}</button>
                      <button mat-menu-item
                        (click)="sellersPeriod.set('1 year')">{{'LastYear' |
                        transloco}}</button>
                    </mat-menu>
                  </div>
                </div>
                <div class="mt-2 flex h-32 flex-auto flex-col">
                  <apx-chart
                    class="flex h-full w-full flex-auto items-center justify-center"
                    [chart]="chartTopSellers?.chart"
                    [colors]="chartTopSellers?.colors"
                    [labels]="chartTopSellers?.labels"
                    [plotOptions]="chartTopSellers?.plotOptions"
                    [series]="chartTopSellers?.series"
                    [states]="chartTopSellers?.states"
                    [tooltip]="chartTopSellers?.tooltip"></apx-chart>
                </div>
                <div class="mt-2">
                  <div class="-my-3 divide-y">
                    @for (
                    dataset of topSellersDataSource.data;
                    track dataset;
                    let i = $index
                    ) {
                    <div class="grid grid-cols-3 py-3">
                      <div class="flex items-center">
                        <div
                          class="h-2 w-2 flex-0 rounded-full"
                          [style.backgroundColor]="
                                            chartTopSellers?.colors[i]
                                        "></div>
                        <div class="ml-3 truncate">
                          {{ topSellersDataSource.data[i].sellerName }}
                        </div>
                      </div>
                      <div class="text-right font-medium">
                      </div>
                      <div class="text-secondary text-right">
                        {{ dataset.amountSold | currency: 'CHF' }}
                      </div>
                    </div>
                    }
                  </div>
                </div>
              </div>
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div
                  class="bg-card flex flex-col overflow-hidden rounded-2xl p-6 shadow">
                  <div class="flex items-start justify-between">
                    <div
                      class="truncate text-lg font-medium leading-6 tracking-tight">
                      {{'Delivered' | transloco}}
                    </div>
                    <!-- <div class="-mr-3 -mt-2 ml-2">
                      <button
                        mat-icon-button
                        [matMenuTriggerFor]="summaryMenu">
                        <mat-icon
                          class="icon-size-5"
                          [svgIcon]="
                                                    'heroicons_mini:ellipsis-vertical'
                                                "></mat-icon>
                      </button>
                      <mat-menu #summaryMenu="matMenu">
                        <button mat-menu-item>
                          Last 30 days
                        </button>
                      </mat-menu>
                    </div> -->
                  </div>
                  <div class="mt-2 flex flex-col items-center">
                    <div
                      class="text-8xl mt-4 font-bold leading-none tracking-tight text-blue-500 sm:text-8xl">
                      {{data().delivered}}
                    </div>
                  </div>
                </div>
                <!-- Overdue -->
                <div
                  class="bg-card flex flex-col overflow-hidden rounded-2xl p-6 shadow">
                  <div class="flex items-start justify-between">
                    <div
                      class="truncate text-lg font-medium leading-6 tracking-tight">
                      {{'PendingDeliveries' | transloco}}
                    </div>
                    <!-- <div class="-mr-3 -mt-2 ml-2">
                      <button
                        mat-icon-button
                        [matMenuTriggerFor]="overdueMenu">
                        <mat-icon
                          class="icon-size-5"
                          [svgIcon]="
                                                    'heroicons_mini:ellipsis-vertical'
                                                "></mat-icon>
                      </button>
                      <mat-menu #overdueMenu="matMenu">
                        <button mat-menu-item>
                          Yesterday
                        </button>
                        <button mat-menu-item>
                          2 days ago
                        </button>
                        <button mat-menu-item>
                          3 days ago
                        </button>
                      </mat-menu>
                    </div> -->
                  </div>
                  <div class="mt-2 flex flex-col items-center">
                    <div
                      class="text-8xl mt-4 font-bold leading-none tracking-tight text-red-500 sm:text-8xl">
                      {{data().upcomingDelivery}}
                    </div>
                  </div>
                </div>
                <div
                  class="bg-card flex flex-col overflow-hidden rounded-2xl p-6 shadow">
                  <div class="flex items-start justify-between">
                    <div
                      class="truncate text-lg font-medium leading-6 tracking-tight">
                      {{'FinishedTestDrives' | transloco}}
                    </div>
                    <!-- <div class="-mr-3 -mt-2 ml-2">
                      <button
                        mat-icon-button
                        [matMenuTriggerFor]="issuesMenu">
                        <mat-icon
                          class="icon-size-5"
                          [svgIcon]="
                                                    'heroicons_mini:ellipsis-vertical'
                                                "></mat-icon>
                      </button>
                      <mat-menu #issuesMenu="matMenu">
                        <button mat-menu-item>
                          Yesterday
                        </button>
                        <button mat-menu-item>
                          2 days ago
                        </button>
                        <button mat-menu-item>
                          3 days ago
                        </button>
                      </mat-menu>
                    </div> -->
                  </div>
                  <div class="mt-2 flex flex-col items-center">
                    <div
                      class="text-8xl mt-4 font-bold leading-none tracking-tight text-amber-500 sm:text-8xl">
                      {{data().finishedTestDrives}}
                    </div>
                  </div>
                </div>
                <!-- Features -->
                <div
                  class="bg-card flex flex-col overflow-hidden rounded-2xl p-6 shadow">
                  <div class="flex items-start justify-between">
                    <div
                      class="truncate text-lg font-medium leading-6 tracking-tight">
                      {{'UpcomingTestDrives' | transloco}}
                    </div>
                    <!-- <div class="-mr-3 -mt-2 ml-2">
                      <button
                        mat-icon-button
                        [matMenuTriggerFor]="featuresMenu">
                        <mat-icon
                          class="icon-size-5"
                          [svgIcon]="
                                                    'heroicons_mini:ellipsis-vertical'
                                                "></mat-icon>
                      </button>
                      <mat-menu #featuresMenu="matMenu">
                        <button mat-menu-item>
                          Yesterday
                        </button>
                        <button mat-menu-item>
                          2 days ago
                        </button>
                        <button mat-menu-item>
                          3 days ago
                        </button>
                      </mat-menu>
                    </div> -->
                  </div>
                  <div class="mt-2 flex flex-col items-center">
                    <div
                      class="text-8xl mt-4 font-bold leading-none tracking-tight text-green-500 sm:text-8xl">
                      {{data().upcomingTestDrives}}
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl p-6  shadow">
                <div class="flex items-start justify-between">
                  <div
                    class="truncate text-lg font-medium leading-6 tracking-tight">
                    {{'Buyer' | transloco}}
                  </div>
                  <div class="ml-2">
                    <button
                      class="bg-hover h-6 min-h-6 rounded-full px-2"
                      mat-button
                      [matMenuTriggerFor]="buyersMenu">
                      <span
                        class="text-secondary text-sm font-medium">{{buyersPeriod() | transloco}}</span>
                    </button>
                    <mat-menu #buyersMenu="matMenu">
                      <button mat-menu-item
                        (click)="buyersPeriod.set('30 days')">{{'Last30Days' |
                        transloco }}</button>
                      <button mat-menu-item
                        (click)="buyersPeriod.set('3 months')">{{'Last3Months' |
                        transloco}}</button>
                      <button mat-menu-item
                        (click)="buyersPeriod.set('6 months')">{{'Last6Months' |
                        transloco}}</button>
                      <button mat-menu-item
                        (click)="buyersPeriod.set('9 months')">{{'Last9Months' |
                        transloco}}
                      </button>
                      <button mat-menu-item
                        (click)="buyersPeriod.set('1 year')">{{'LastYear' |
                        transloco}}</button>
                    </mat-menu>
                  </div>
                </div>
                <div class="mt-2 flex h-32 flex-auto flex-col">
                  <apx-chart
                    class="flex h-full w-full flex-auto items-center justify-center"
                    [chart]="chartTopBuyers?.chart"
                    [colors]="chartTopBuyers?.colors"
                    [labels]="chartTopBuyers?.labels"
                    [plotOptions]="chartTopBuyers?.plotOptions"
                    [series]="chartTopBuyers?.series"
                    [states]="chartTopBuyers?.states"
                    [tooltip]="chartTopBuyers?.tooltip"></apx-chart>
                </div>
                <div class="mt-2">
                  <div class="-my-3 divide-y">
                    @for (
                    dataset of topBuyersDataSource.data;
                    track $index;
                    let i = $index
                    ) {
                    <div class="grid grid-cols-3 py-3">
                      <div class="flex items-center">
                        <div
                          class="h-2 w-2 flex-0 rounded-full"
                          [style.backgroundColor]="
                                            chartTopBuyers?.colors[i]
                                        "></div>
                        <div class="ml-3 truncate">
                          {{ topBuyersDataSource.data[i].buyerName }}
                        </div>
                      </div>
                      <div class="text-right font-medium">
                        <!-- {{
                        (data().gender?.uniqueVisitors * dataset) /
                        100 | number: '1.0-0'
                        }} -->
                      </div>
                      <div class="text-secondary text-right">
                        {{ dataset.amountBought | currency: 'CHF' }}
                      </div>
                    </div>
                    }
                  </div>
                </div>
              </div>
            </div>

          </ng-template>
        </mat-tab>

        <!-- <mat-tab label="Delivery Calendar">
          <ng-template matTabContent>
            <app-delivery-calendar-salesperson></app-delivery-calendar-salesperson>
          </ng-template>
        </mat-tab>

        <mat-tab label="Contracts In Progress List">
          <ng-template matTabContent>
            <app-contracts-in-progress-salesperson></app-contracts-in-progress-salesperson>
          </ng-template>
        </mat-tab>

        <mat-tab label="Reserved Vehicles List">
          <ng-template matTabContent>
            <app-vehicles-i-reserved></app-vehicles-i-reserved>
          </ng-template>
        </mat-tab> -->

      </mat-tab-group>
    </div>
  </div>
</div>

<!-- <div class="flex flex-col gap-6 w-full">

  <h1 class="m-5 text-xl">Mandat Dashboard</h1>

  <div class="w-full">
    <app-top-performing-sales-people></app-top-performing-sales-people>
  </div>

  <div class="w-full">
    <app-sales-overview></app-sales-overview>
  </div>

  <div class="w-full">
    <app-mfk-notifications-admin></app-mfk-notifications-admin>
  </div>

  <div class="w-full">
    <app-vehicles-in-stock-summary></app-vehicles-in-stock-summary>
  </div>

  <div class="w-full">
    <app-new-cars-this-week-admin></app-new-cars-this-week-admin>
  </div>

</div> -->

